export default [
    // { key: 'home', label: 'Home' },
    // { key: 'about', label: 'About' },
    // { key: 'contact', label: 'Contact' },
]